import { useRef } from "react";

import { checkInputFileSize } from "@kraaft/helper-functions";

interface FileInputOptions {
  onAccepted: (files: File[]) => void;
  accept?: string | string[];
  maxSize?: number;
  multiple?: boolean;
}

interface FileError {
  message: string;
  code: string;
}

interface FileRejection {
  file: File;
  errors: FileError[];
}

export function useFileInput({
  onAccepted,
  accept,
  maxSize,
  multiple = true,
}: FileInputOptions) {
  const input = useRef<HTMLInputElement>(null);

  let fileRejections: FileRejection[] = [];

  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    const files = e.target?.files && Array.from(e.target?.files);

    const result = checkInputFileSize({ files, accept, maxSize });

    if (result === undefined) {
      return;
    }

    if (result.status) {
      onAccepted(result.acceptedFiles);
    }

    ({ fileRejections } = result);

    // reset input
    if (input.current) {
      input.current.value = "";
    }
  }

  function getInputProps() {
    return {
      accept: Array.isArray(accept) ? accept.join(",") : accept,
      ref: input,
      type: "file",
      onChange,
      hidden: true,
      multiple,
    };
  }

  function open() {
    input.current?.click();
  }

  return { fileRejections, getInputProps, open };
}
